import React, { Component } from 'react';

interface EmmaItemProps {
  emmaItemClass: string;
  leftComponent: any;
  rightComponent: any;
}

interface EmmaItemState {}

class EmmaItem extends Component<EmmaItemProps, EmmaItemState> {
  componentDidMount() {}

  render() {
    const { leftComponent, rightComponent, emmaItemClass } = this.props;
    return (
      <div className={`${emmaItemClass} content-align-level`}>
        {leftComponent}
        {rightComponent}
      </div>
    );
  }
}

export default EmmaItem;
